import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcChevronLeft20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m13 15.006c0 .53-.431.994-.995.994-.266 0-.531-.133-.697-.298l-5.01-5.006a1.01 1.01 0 0 1 -.298-.696c0-.227.073-.455.22-.62l5.088-5.082c.166-.199.431-.298.697-.298.564 0 .995.464.995.994 0 .266-.1.53-.299.73l-4.28 4.276 4.28 4.276c.2.2.299.464.299.73z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcChevronLeft20;
